import convert from "xml-js"
import mensajePreventivo from "../mensajes/mensajePreventivo";

export default async function expediente(idAutorizacion) {
    try {
        const response = await fetch(`/api/webservice/obtener?idautorizacion=${idAutorizacion}`);
        const data = await response.json();
        const xml = data.data;
        const resultadoJson = convert.xml2json(xml, { compact: true, spaces: 4 });
        const resultado = JSON.parse(resultadoJson);
        const dataResult = resultado["soap:Envelope"]["soap:Body"]["WSConsultarByAutorizacionResponse"]
        ["WSConsultarByAutorizacionResult"]["diffgr:diffgram"]["NewDataSet"]["Table"];
        const { NoExpedienteActual, NombreConcecionarioActual, PlacasActual } = dataResult;
        const finalObject = {
            NoExpedienteActual: NoExpedienteActual._text,
            NombreConcecionarioActual: NombreConcecionarioActual._text,
            PlacasActual: PlacasActual._text
        }
        return finalObject;
    } catch (error) {
        mensajePreventivo("Número de expediente no encontrado en el WebService", 2500);
    }
}